<div class="h-full flex flex-col">
  <div class="flex-1 flex flex-col relative">

<div class="p-6 pb-3">

  <!-- Mobile actions -->
  <div class="sm:hidden">
    <div class="flex items-center justify-end space-x-2">
      <button type="button" (click)="onCreateIcp()" class="inline-flex items-center gap-x-1.5 rounded-md bg-primary px-2.5 py-2 text-sm font-medium text-white shadow-xs hover:opacity-90">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="-ml-0.5 size-5">
          <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
        </svg>
        Create ICP
      </button>
    </div>
  </div>

  <!-- Desktop actions -->
  <div class="hidden sm:flex sm:items-center sm:justify-end">
    <!-- Actions -->
    <div class="flex items-center space-x-3">
      <!-- Create ICP -->
      <button type="button" (click)="onCreateIcp()" class="inline-flex items-center gap-x-1.5 rounded-md bg-primary px-2.5 py-2 text-sm font-medium text-white shadow-xs hover:opacity-90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="-ml-0.5 size-5">
          <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
        </svg>
        Create ICP
      </button>
    </div>
  </div>

    <!-- Error State -->
    <div *ngIf="error$ | async as error" class="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4">
      <p class="font-semibold">Error:</p>
      <p>{{ error }}</p>
    </div>

    <!-- Content -->
    <div class="mt-6">
      <!-- Mobile Layout (Horizontal scroll only) -->
      <div class="sm:hidden">
        <div class="rounded-xl border border-gray-200 overflow-hidden relative">
          <div class="overflow-x-auto">
            <table class="min-w-full divide-y divide-gray-200 border-b border-gray-200">
              <thead class="bg-gray-50">
              <tr>
                <th scope="col" class="py-3.5 pr-3 pl-4 text-left text-sm font-semibold text-gray-700 whitespace-nowrap">ICP</th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700 whitespace-nowrap">Actions</th>
              </tr>
              </thead>
              <tbody class="divide-y divide-gray-200 bg-white">
              <tr *ngFor="let icp of paginatedIcps" class="hover:bg-gray-50 cursor-pointer" (click)="onViewIcp(icp)">
                <td class="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900">
                  <div class="flex items-center space-x-3">
                    <div class="size-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                      <span class="text-primary text-sm font-medium">{{ icp.name?.charAt(0)?.toUpperCase() || 'I' }}</span>
                    </div>
                    <span>{{ icp.name }}</span>
                  </div>
                </td>
                <td class="py-4 pr-4 pl-3">
                  <div class="flex items-center space-x-1">
                    <!-- Edit -->
                    <button type="button" (click)="$event.stopPropagation(); onEditIcp(icp)" class="bg-gray-100 hover:opacity-90 p-2 rounded-full">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4 text-gray-500">
                        <path d="m2.695 14.762-1.262 3.155a.5.5 0 0 0 .65.65l3.155-1.262a4 4 0 0 0 1.343-.886L17.5 5.501a2.121 2.121 0 0 0-3-3L3.58 13.419a4 4 0 0 0-.885 1.343Z" />
                      </svg>
                    </button>

                    <!-- Delete -->
                    <button type="button" (click)="$event.stopPropagation(); onDeleteIcp(icp)" class="bg-red-50 hover:opacity-90 p-2 rounded-full" *ngIf="!icp.is_default">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4 text-red-500">
                        <path fill-rule="evenodd" d="M8.75 1A2.75 2.75 0 0 0 6 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 1 0 .23 1.482l.149-.022.841 10.518A2.75 2.75 0 0 0 7.596 19h4.807a2.75 2.75 0 0 0 2.742-2.53l.841-10.52.149.023a.75.75 0 0 0 .23-1.482A41.03 41.03 0 0 0 14 4.193V3.75A2.75 2.75 0 0 0 11.25 1h-2.5ZM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4ZM8.58 7.72a.75.75 0 0 0-1.5.06l.3 7.5a.75.75 0 1 0 1.5-.06l-.3-7.5Zm4.34.06a.75.75 0 1 0-1.5-.06l-.3 7.5a.75.75 0 1 0 1.5.06l.3-7.5Z" clip-rule="evenodd" />
                      </svg>
                    </button>

                    <!-- Duplicate -->
                    <button type="button" (click)="$event.stopPropagation(); onDuplicateIcp(icp)" class="bg-blue-50 hover:opacity-90 p-2 rounded-full">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4 text-blue-500">
                        <path d="M7 3.5A1.5 1.5 0 0 1 8.5 2h3.879a1.5 1.5 0 0 1 1.06.44l3.122 3.12A1.5 1.5 0 0 1 17 6.622V12.5a1.5 1.5 0 0 1-1.5 1.5h-1v-3.379a3 3 0 0 0-.879-2.121L10.5 5.379A3 3 0 0 0 8.379 4.5H7v-1Z" />
                        <path d="M4.5 6A1.5 1.5 0 0 0 3 7.5v9A1.5 1.5 0 0 0 4.5 18h7a1.5 1.5 0 0 0 1.5-1.5v-5.879a1.5 1.5 0 0 0-.44-1.06L9.44 6.439A1.5 1.5 0 0 0 8.378 6H4.5Z" />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <!-- Loading State for Mobile -->
          <div *ngIf="loading$ | async">
            <div class="text-center py-12">
              <svg class="animate-spin h-6 w-6 text-primary mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </div>
          </div>

          <!-- Empty State Overlay for Mobile -->
          <div *ngIf="!(loading$ | async) && paginatedIcps.length === 0">
            <div class="text-center py-12">
              <h3 class="text-sm font-medium text-gray-900">No ICPs found</h3>
              <p class="mt-1 text-sm text-gray-500">Get started by creating a new ICP.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Desktop Layout (With internal scroll) -->
      <div class="hidden sm:block sm:flex-1 sm:flex sm:flex-col">
        <!-- Table Container with Border -->
        <div class="rounded-xl border border-gray-200 overflow-hidden flex flex-col relative" [style.height.px]="tableHeight">

          <!-- Scrollable Container -->
          <div class="flex-1 overflow-y-scroll custom-scroll">
            <table class="min-w-full divide-y divide-gray-200 border-b border-gray-200">
              <!-- Fixed Header -->
              <thead class="bg-gray-50 sticky top-0 z-20">
              <tr>
                <th scope="col" class="py-3.5 pr-3 pl-4 text-left text-sm font-semibold text-gray-700 sm:pl-6 bg-gray-50 z-20">ICP</th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700 bg-gray-50 z-20">Description</th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700 bg-gray-50 z-20">Status</th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700 bg-gray-50 z-20">Workspaces</th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700 bg-gray-50 z-20">Created</th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700 bg-gray-50 w-40 z-20">Actions</th>
              </tr>
              </thead>
              <!-- Table Body -->
              <tbody class="divide-y divide-gray-200 bg-white">
              <tr *ngFor="let icp of paginatedIcps" class="hover:bg-gray-50 cursor-pointer" (click)="onViewIcp(icp)">
                <td class="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-6">
                  <div class="flex items-center space-x-3">
                    <div class="size-10 rounded-lg bg-violet-500/10 flex items-center justify-center flex-shrink-0">
                      <span class="text-violet-500 text-sm font-medium">{{ icp.name?.charAt(0)?.toUpperCase() || 'I' }}</span>
                    </div>
                    <span>{{ icp.name }}</span>
                  </div>
                </td>
                <td class="px-3 py-4 text-sm whitespace-nowrap text-gray-500">{{ icp.description || 'No description' }}</td>
                <td class="px-3 py-4 text-sm whitespace-nowrap text-gray-500">
                  <span [class]="getStatusBadgeClass(icp)" class="inline-flex rounded-full px-2 text-xs font-medium leading-5">
                    {{ icp.is_default ? 'Default' : 'Custom' }}
                  </span>
                </td>
                <td class="px-3 py-4 text-sm whitespace-nowrap text-gray-500 relative hover:z-30">
                  <div *ngIf="icp.workspaces && icp.workspaces.length > 0" class="isolate flex -space-x-2">
                    <div *ngFor="let ws of icp.workspaces; let i = index"
                         class="group relative inline-flex items-center justify-center size-8 rounded-full ring-2 ring-white bg-violet-500 text-xs font-medium text-white cursor-default"
                         [style.z-index]="icp.workspaces.length - i">
                      {{ ws.name_acronym }}
                      <span class="pointer-events-none absolute bottom-full mb-2 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-lg bg-gray-900 px-2.5 py-1.5 text-xs font-medium text-white opacity-0 group-hover:opacity-100 transition-opacity z-50">
                        {{ ws.name }}
                      </span>
                    </div>
                  </div>
                  <a *ngIf="!icp.workspaces || icp.workspaces.length === 0"
                     routerLink="/workspaces"
                     (click)="$event.stopPropagation()"
                     class="inline-flex items-center px-2 py-1 text-xs font-medium text-violet-600 bg-violet-50 rounded-md hover:bg-violet-100 transition-colors">
                    Create Workspace
                  </a>
                </td>
                <td class="px-3 py-4 text-sm whitespace-nowrap text-gray-500">{{ formatDate(icp.created_at) }}</td>
                <td class="py-4 pr-4 pl-3 sm:pr-6 w-40">
                  <div class="flex items-center space-x-1">
                    <!-- Edit -->
                    <button type="button" (click)="$event.stopPropagation(); onEditIcp(icp)" class="bg-gray-100 hover:opacity-90 p-2 rounded-full">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4 text-gray-500">
                        <path d="m2.695 14.762-1.262 3.155a.5.5 0 0 0 .65.65l3.155-1.262a4 4 0 0 0 1.343-.886L17.5 5.501a2.121 2.121 0 0 0-3-3L3.58 13.419a4 4 0 0 0-.885 1.343Z" />
                      </svg>
                    </button>

                    <!-- Delete -->
                    <button type="button" (click)="$event.stopPropagation(); onDeleteIcp(icp)" class="bg-red-50 hover:opacity-90 p-2 rounded-full" *ngIf="!icp.is_default">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4 text-red-500">
                        <path fill-rule="evenodd" d="M8.75 1A2.75 2.75 0 0 0 6 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 1 0 .23 1.482l.149-.022.841 10.518A2.75 2.75 0 0 0 7.596 19h4.807a2.75 2.75 0 0 0 2.742-2.53l.841-10.52.149.023a.75.75 0 0 0 .23-1.482A41.03 41.03 0 0 0 14 4.193V3.75A2.75 2.75 0 0 0 11.25 1h-2.5ZM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4ZM8.58 7.72a.75.75 0 0 0-1.5.06l.3 7.5a.75.75 0 1 0 1.5-.06l-.3-7.5Zm4.34.06a.75.75 0 1 0-1.5-.06l-.3 7.5a.75.75 0 1 0 1.5.06l.3-7.5Z" clip-rule="evenodd" />
                      </svg>
                    </button>

                    <!-- Duplicate -->
                    <button type="button" (click)="$event.stopPropagation(); onDuplicateIcp(icp)" class="bg-blue-50 hover:opacity-90 p-2 rounded-full">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4 text-blue-500">
                        <path d="M7 3.5A1.5 1.5 0 0 1 8.5 2h3.879a1.5 1.5 0 0 1 1.06.44l3.122 3.12A1.5 1.5 0 0 1 17 6.622V12.5a1.5 1.5 0 0 1-1.5 1.5h-1v-3.379a3 3 0 0 0-.879-2.121L10.5 5.379A3 3 0 0 0 8.379 4.5H7v-1Z" />
                        <path d="M4.5 6A1.5 1.5 0 0 0 3 7.5v9A1.5 1.5 0 0 0 4.5 18h7a1.5 1.5 0 0 0 1.5-1.5v-5.879a1.5 1.5 0 0 0-.44-1.06L9.44 6.439A1.5 1.5 0 0 0 8.378 6H4.5Z" />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <!-- Loading State Overlay -->
          <div *ngIf="loading$ | async" class="absolute inset-0 flex items-center justify-center bg-white">
            <div class="text-center">
              <svg class="animate-spin h-6 w-6 text-primary mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </div>
          </div>

          <!-- Empty State Overlay -->
          <div *ngIf="!(loading$ | async) && paginatedIcps.length === 0" class="absolute inset-0 flex items-center justify-center bg-white">
            <div class="text-center">
              <h3 class="text-sm font-medium text-gray-900">No ICPs found</h3>
              <p class="mt-1 text-sm text-gray-500">Get started by creating a new ICP.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div *ngIf="!(loading$ | async) && paginatedIcps.length > 0" class="mt-3 flex items-center justify-between bg-white dark:bg-indigo-custom">
      <app-crm-pagination (perPageChanged)="onPerPageChanged($event)" (pageChanged)="onPageChanged($event)" [pagination]="pagination" class="w-full"></app-crm-pagination>
    </div>

  </div>
</div>
